import React from 'react';
import { motion } from 'framer-motion';
import { workbooks } from '../data/content';
export function WorkbooksSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-256" data-mp="343f6zsccnqx7">
      <div className="mx-auto max-w-5xl" data-id="element-257" data-mp="2zbovvk5l8z4q">
        <div className="mx-auto max-w-2xl text-center" data-id="element-258" data-mp="2zadqxh0eplc1">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-259" data-mp="2udvo4momzx2c">
            5 volumi completi
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-260" data-mp="2qcto43mwbgzb">
            Materiali organizzati per argomento, per ogni area fondamentale della chimica
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-261" data-mp="2gduo19g74tnx">
          {workbooks.map((workbook, i) => <motion.article key={workbook.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex gap-4 rounded-2xl border border-cobalt/25 bg-white p-5 shadow-sm shadow-cobalt/5 sm:gap-6 sm:p-7" data-id="element-262" data-mp="2bg2ivdqjjb1s" data-mpi={i}>
              <div className="flex min-w-0 flex-1" data-id="element-263" data-mp="1l5i40zmej6s0">
                <div className="flex flex-col" data-id="element-264" data-mp="1l6s4fvgq8r1t">
                  <span className="font-serif-display text-3xl font-bold leading-none text-cobalt sm:text-4xl" data-id="element-265" data-mp="1q4lc6sxoht47">
                    {workbook.number}
                  </span>
                  <h3 className="mt-3 text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-266" data-mp="2dw8uwnksdxve">
                    {workbook.title}
                  </h3>
                  <p className="mt-1 text-sm font-medium leading-snug text-cobalt-deep" data-id="element-267" data-mp="2454erkjdk6yz">
                    {workbook.subtitle}
                  </p>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-268" data-mp="291cp8kmmnbzt">
                    {workbook.description}
                  </p>
                  <span className="mt-5 inline-block w-fit rounded-full bg-cobalt/10 px-3 py-1 text-xs font-medium text-cobalt-deep" data-id="element-269" data-mp="31k04vkiutyti">
                    {workbook.tag}
                  </span>
                </div>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-cobalt/10 p-1.5" data-id="element-270" data-mp="36h5nuncv8u87">
                <img src={workbook.coverImage} alt={`Volume ${workbook.number}: ${workbook.title}`} loading="lazy" className="block h-[110px] w-[110px] rounded-lg object-contain sm:h-[150px] sm:w-[150px]" data-id="element-271" data-mp="32dpp9lh8kjsv" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}